import { z } from "zod";

export const getSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      companyId: z.string(),
      userId: z.string(),
      createdAt: z.number().int().optional(),
      updatedAt: z.number().int().optional(),
      archived: z.boolean().optional(),
    }),
  ),
});
export const emptyResponseSchema = z.object({});
export const getBoardsResponseSchema = z.object({
  boards: z.array(
    z.union([
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("team"),
        stickyScale: z.number().optional(),
        teamId: z.number().int(),
        artId: z.number().int().optional(),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("risk"),
        stickyScale: z.number().optional(),
        artId: z.number().int().optional(),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("program"),
        stickyScale: z.number().optional(),
        artId: z.number().int().optional(),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("backlog"),
        stickyScale: z.number().optional(),
        artId: z.number().int().optional(),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("solution"),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("solution_backlog"),
      }),
      z.object({
        id: z.string(),
        sessionId: z.string().optional(),
        boardType: z.literal("flex"),
        flexboardType: z.string(),
        name: z.string(),
      }),
    ]),
  ),
});
export const getStickyResponseSchema = z.object({
  sticky: z
    .object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJF_value: z.union([z.number(), z.string()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.number().int().optional(),
      iterationNumber: z.number().int().optional(),
      almSource: z.union([z.number().int(), z.string()]).optional(),
      storyPoints: z.number().optional(),
      risk: z.string().optional(),
      dependTeamId: z.number().int().optional(),
      dependTeam: z.string().optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.string().optional(),
      stickyGroup: z.string().optional(),
      artId: z.number().int().optional(),
      transition: z.string().optional(),
      reactions: z.record(z.any()).optional(),
      assignee: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      reporter: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      stepValue: z.number().int().optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
    })
    .optional(),
});
export const getAlmStickiesResponseSchema = z.object({
  stickies: z.array(
    z.object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJF_value: z.union([z.number(), z.string()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.number().int().optional(),
      iterationNumber: z.number().int().optional(),
      almSource: z.union([z.number().int(), z.string()]).optional(),
      storyPoints: z.number().optional(),
      risk: z.string().optional(),
      dependTeamId: z.number().int().optional(),
      dependTeam: z.string().optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.string().optional(),
      stickyGroup: z.string().optional(),
      artId: z.number().int().optional(),
      transition: z.string().optional(),
      reactions: z.record(z.any()).optional(),
      assignee: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      reporter: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      stepValue: z.number().int().optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
    }),
  ),
});
export const getAlmStickiesAcrossSessionsResponseSchema = z.object({
  stickies: z.array(
    z
      .object({
        sticky: z.object({
          id: z.string(),
          almIssueId: z.union([z.number().int(), z.string()]).optional(),
          boardId: z.string(),
          WSJF_value: z.union([z.number(), z.string()]).optional(),
          almIssueUrl: z.string().optional(),
          stackPos: z.number().int().optional(),
          text: z.string().optional(),
          typeId: z.string(),
          statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
          status: z.string().optional(),
          aCenter: z.tuple([z.number(), z.number()]).optional(),
          teamId: z.number().int().optional(),
          iterationNumber: z.number().int().optional(),
          almSource: z.union([z.number().int(), z.string()]).optional(),
          storyPoints: z.number().optional(),
          risk: z.string().optional(),
          dependTeamId: z.number().int().optional(),
          dependTeam: z.string().optional(),
          objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
          precondTeamId: z.number().int().optional(),
          precondTeam: z.string().optional(),
          flagType: z.string().optional(),
          stickyGroup: z.string().optional(),
          artId: z.number().int().optional(),
          transition: z.string().optional(),
          reactions: z.record(z.any()).optional(),
          assignee: z
            .object({ pipId: z.string().optional(), almId: z.string().optional() })
            .optional(),
          reporter: z
            .object({ pipId: z.string().optional(), almId: z.string().optional() })
            .optional(),
          stepValue: z.number().int().optional(),
          templateId: z.string().optional(),
          isOrigin: z.boolean().optional(),
        }),
        sessionId: z.string(),
        boardId: z.string(),
        boardType: z.enum([
          "team",
          "risk",
          "program",
          "solution",
          "solution_backlog",
          "backlog",
          "flex",
        ]),
        stickyType: z.object({
          id: z.string(),
          sessionId: z.string(),
          name: z.string(),
          color: z.array(z.number()),
          altColor: z.array(z.number()).optional(),
          originBoardType: z.string().optional(),
          originFlexboardType: z.string().optional(),
          almType: z.string().optional(),
          availableBoardTypes: z
            .array(
              z.enum([
                "team",
                "risk",
                "program",
                "solution",
                "solution_backlog",
                "backlog",
                "flex",
              ]),
            )
            .optional(),
          availableFlexboardTypes: z.array(z.string()).optional(),
          templateId: z.string().optional(),
          functionality: z.enum(["workitem", "note", "risk", "dependency"]),
          stepEstimate: z.boolean().optional(),
          stepEstimateValues: z
            .array(z.object({ text: z.string(), value: z.number().int() }))
            .optional(),
        }),
      })
      .describe("Sticky with session context for cross-session queries"),
  ),
});
export const getBoardResponseSchema = z.object({
  board: z.union([
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("team"),
      stickyScale: z.number().optional(),
      teamId: z.number().int(),
      artId: z.number().int().optional(),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("risk"),
      stickyScale: z.number().optional(),
      artId: z.number().int().optional(),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("program"),
      stickyScale: z.number().optional(),
      artId: z.number().int().optional(),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("backlog"),
      stickyScale: z.number().optional(),
      artId: z.number().int().optional(),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("solution"),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("solution_backlog"),
    }),
    z.object({
      id: z.string(),
      sessionId: z.string().optional(),
      boardType: z.literal("flex"),
      flexboardType: z.string(),
      name: z.string(),
    }),
  ]),
});
export const getIterationsResponseSchema = z.object({
  iterations: z.array(
    z.object({
      id: z.number().int(),
      start: z.number().int(),
      end: z.number().int(),
      name: z.string(),
      order: z.number().int(),
      teams: z
        .array(
          z.object({
            teamId: z.number().int(),
            sources: z.array(
              z.object({ id: z.number().int().optional(), sprint: z.number().int().optional() }),
            ),
          }),
        )
        .optional(),
    }),
  ),
});
export const getTeamsResponseSchema = z.object({
  teams: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      boardId: z.string(),
      archived: z.boolean(),
      external: z.boolean(),
      artId: z.number().int().optional(),
    }),
  ),
});
export const getSessionTeamIdsMappingResponseSchema = z.object({
  mapping: z.array(z.object({ sessionId: z.string(), teamIds: z.array(z.number().int()) })),
});
export const getArtsResponseSchema = z.object({
  arts: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      teams: z.array(z.object({ id: z.number().int(), name: z.string() })),
    }),
  ),
});
export const getSettingsResponseSchema = z.object({
  settings: z
    .object({
      iterationLoadCritical: z.number().int().optional(),
      confirmStickyDelete: z.boolean().optional(),
      teamForbidStickyDelete: z.boolean().optional(),
      moveActivated: z.boolean().optional(),
      iterationLoadWarn: z.number().int().optional(),
      backlog_forbid_JIRA_sticky_delete: z.boolean().optional(),
      backlog_forbid_WSJF_edit: z.boolean().optional(),
      backlog_synchronize_ADO_iteration: z.boolean().optional(),
      backlogMirrorAssignedStickiesToTeamBoard: z.boolean().optional(),
      backlogSynchronizeRallyTeams: z.boolean().optional(),
      teamMoveUnmappedToBacklog: z.boolean().optional(),
    })
    .optional(),
});
export const getLinkTypesResponseSchema = z.object({
  linkTypes: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      fromStickyType: z.string(),
      toStickyType: z.string(),
    }),
  ),
});
export const getLinksResponseSchema = z.object({
  links: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      fromStickyId: z.string(),
      toStickyId: z.string(),
      linkTypeId: z.string().optional(),
    }),
  ),
});
export const createLinksResponseSchema = z.object({
  links: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      fromStickyId: z.string(),
      toStickyId: z.string(),
      linkTypeId: z.string().optional(),
    }),
  ),
});
export const getSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    name: z.string(),
    companyId: z.string(),
    userId: z.string(),
    createdAt: z.number().int().optional(),
    updatedAt: z.number().int().optional(),
    archived: z.boolean().optional(),
  }),
});
export const getDependenciesResponseSchema = z.object({
  dependencies: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      dependentSessionId: z.string(),
      dependencyType: z.enum(["blocks", "requires", "related"]),
      createdAt: z.number().int().optional(),
    }),
  ),
});
export const createDependenciesResponseSchema = z.object({
  dependencies: z.array(
    z.object({
      id: z.string(),
      sessionId: z.string(),
      dependentSessionId: z.string(),
      dependencyType: z.enum(["blocks", "requires", "related"]),
      createdAt: z.number().int().optional(),
    }),
  ),
});
export const getSessionNameResponseSchema = z.object({ name: z.string().optional() });
export const getPlanningDatesResponseSchema = z.object({
  start: z.number().int().optional(),
  end: z.number().int().optional(),
});
export const getParticipatingUsersResponseSchema = z.object({ teamIds: z.array(z.number().int()) });
export const getStickerTypesResponseSchema = z.object({
  stickerTypes: z.array(
    z
      .object({
        icon: z.enum(["flag", "check_mark", "dot", "star", "question_mark", "exclamation_mark"]),
        color: z.enum(["red", "orange", "yellow", "blue", "purple", "green"]),
        label: z.string(),
      })
      .describe("Sticker type embedded on the session document. Order is preserved by the array."),
  ),
});
export const setStickerTypesResponseSchema = z.object({
  stickerTypes: z.array(
    z
      .object({
        icon: z.enum(["flag", "check_mark", "dot", "star", "question_mark", "exclamation_mark"]),
        color: z.enum(["red", "orange", "yellow", "blue", "purple", "green"]),
        label: z.string(),
      })
      .describe("Sticker type embedded on the session document. Order is preserved by the array."),
  ),
});
export const createLinkTypeResponseSchema = z.object({
  linkType: z.object({
    id: z.string(),
    sessionId: z.string(),
    fromStickyType: z.string(),
    toStickyType: z.string(),
  }),
});
export const getLinkTypeResponseSchema = z.object({
  linkType: z
    .object({
      id: z.string(),
      sessionId: z.string(),
      fromStickyType: z.string(),
      toStickyType: z.string(),
    })
    .optional(),
});
export const getStickiesResponseSchema = z.object({
  stickies: z.array(
    z.object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJF_value: z.union([z.number(), z.string()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.number().int().optional(),
      iterationNumber: z.number().int().optional(),
      almSource: z.union([z.number().int(), z.string()]).optional(),
      storyPoints: z.number().optional(),
      risk: z.string().optional(),
      dependTeamId: z.number().int().optional(),
      dependTeam: z.string().optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.string().optional(),
      stickyGroup: z.string().optional(),
      artId: z.number().int().optional(),
      transition: z.string().optional(),
      reactions: z.record(z.any()).optional(),
      assignee: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      reporter: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      stepValue: z.number().int().optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
    }),
  ),
});
export const searchStickiesResponseSchema = z.object({
  stickies: z.array(
    z.object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJF_value: z.union([z.number(), z.string()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.number().int().optional(),
      iterationNumber: z.number().int().optional(),
      almSource: z.union([z.number().int(), z.string()]).optional(),
      storyPoints: z.number().optional(),
      risk: z.string().optional(),
      dependTeamId: z.number().int().optional(),
      dependTeam: z.string().optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.string().optional(),
      stickyGroup: z.string().optional(),
      artId: z.number().int().optional(),
      transition: z.string().optional(),
      reactions: z.record(z.any()).optional(),
      assignee: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      reporter: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      stepValue: z.number().int().optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
    }),
  ),
});
export const hasStickiesOfTypeResponseSchema = z.object({ hasStickies: z.boolean() });
export const getStickyChangesResponseSchema = z.object({
  changes: z.array(
    z.object({
      id: z.string(),
      stickyId: z.string(),
      changeType: z.string(),
      timestamp: z.number().int(),
      userId: z.string().optional(),
      oldValue: z.string().optional(),
      newValue: z.string().optional(),
    }),
  ),
});
export const getStickiesByBoardIdsResponseSchema = z.object({
  stickies: z.array(
    z.object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJF_value: z.union([z.number(), z.string()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.number().int().optional(),
      iterationNumber: z.number().int().optional(),
      almSource: z.union([z.number().int(), z.string()]).optional(),
      storyPoints: z.number().optional(),
      risk: z.string().optional(),
      dependTeamId: z.number().int().optional(),
      dependTeam: z.string().optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.string().optional(),
      stickyGroup: z.string().optional(),
      artId: z.number().int().optional(),
      transition: z.string().optional(),
      reactions: z.record(z.any()).optional(),
      assignee: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      reporter: z.object({ pipId: z.string().optional(), almId: z.string().optional() }).optional(),
      stepValue: z.number().int().optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
    }),
  ),
});
export const hasStickiesOfTypeOnBoardsResponseSchema = z.object({ hasStickies: z.boolean() });
export const createTimerEventResponseSchema = z.object({ eventId: z.string().optional() });
export const getTimerEventsResponseSchema = z.object({ timerEvents: z.array(z.any()) });
export const getStatusDistributionResponseSchema = z.object({
  items: z.array(
    z.object({
      statusClass: z.string(),
      statusName: z.string(),
      totalStoryPoints: z.number(),
      itemsCount: z.number().int(),
      stickyIds: z.array(z.string()),
    }),
  ),
});
export const getCapacityAllocationResponseSchema = z.object({
  items: z
    .array(
      z
        .object({
          teamId: z.string(),
          typeId: z.string(),
          iterationId: z.union([z.number().int(), z.null()]).optional(),
          items: z.number().int(),
          points: z.number(),
        })
        .describe("Story points for a team/type/iteration combination"),
    )
    .describe("Flat array of capacity allocation items"),
  warnings: z.array(z.string()).describe("Warnings about missing or invalid data").default([]),
});
export const getDependencyFlowResponseSchema = z.object({
  items: z
    .array(
      z
        .object({
          precondTeam: z.string().describe("Team that is blocked"),
          precondTeamId: z.number().int().describe("ID of team that is blocked"),
          dependTeam: z
            .union([
              z.string().describe("Team that is blocking, null for unassigned"),
              z.null().describe("Team that is blocking, null for unassigned"),
            ])
            .describe("Team that is blocking, null for unassigned")
            .optional(),
          dependTeamId: z
            .union([
              z.number().int().describe("ID of team that is blocking, null for unassigned"),
              z.null().describe("ID of team that is blocking, null for unassigned"),
            ])
            .describe("ID of team that is blocking, null for unassigned")
            .optional(),
          count: z.number().int().describe("Number of dependency stickies between these teams"),
        })
        .describe("Represents dependency flow between teams for Sankey visualization"),
    )
    .describe("Array of dependency flow items for Sankey visualization"),
  warnings: z.array(z.string()).describe("Warnings about missing or invalid data").default([]),
});
export const getBurndownChartDataResponseSchema = z.object({
  dataPoints: z
    .array(
      z
        .object({
          date: z.string().date().describe("Date in YYYY-MM-DD format"),
          openPoints: z
            .union([
              z.number().describe("Total open story points at end of day, null for future dates"),
              z.null().describe("Total open story points at end of day, null for future dates"),
            ])
            .describe("Total open story points at end of day, null for future dates")
            .optional(),
          openCount: z
            .union([
              z.number().int().describe("Total open stickies at end of day, null for future dates"),
              z.null().describe("Total open stickies at end of day, null for future dates"),
            ])
            .describe("Total open stickies at end of day, null for future dates")
            .optional(),
          changes: z
            .any()
            .superRefine((x, ctx) => {
              const schemas = [
                z
                  .object({
                    completedPoints: z.number().describe("Story points moved to done status"),
                    completedCount: z
                      .number()
                      .int()
                      .describe("Number of stickies moved to done status"),
                    addedPoints: z
                      .number()
                      .describe("Story points added (new stickies or moved into scope)"),
                    addedCount: z.number().int().describe("Number of stickies added"),
                    removedPoints: z
                      .number()
                      .describe("Story points removed (deleted or moved out of scope)"),
                    removedCount: z.number().int().describe("Number of stickies removed"),
                    reestimatedPoints: z
                      .number()
                      .describe("Net change in story points from re-estimation"),
                  })
                  .describe("Summary of changes for a single day in a burndown chart"),
                z.null(),
              ];
              const errors = schemas.reduce<z.ZodError[]>(
                (errors, schema) =>
                  ((result) => (result.error ? [...errors, result.error] : errors))(
                    schema.safeParse(x),
                  ),
                [],
              );
              if (schemas.length - errors.length !== 1) {
                ctx.addIssue({
                  path: ctx.path,
                  code: "invalid_union",
                  unionErrors: errors,
                  message: "Invalid input: Should pass single schema",
                });
              }
            })
            .describe("Summary of changes that occurred this day, null for future dates")
            .optional(),
        })
        .describe("A single day's data point in a burndown chart"),
    )
    .describe("Daily burndown data points"),
});
export const getPredictabilityResponseSchema = z.object({
  sessions: z
    .array(
      z
        .object({
          sessionId: z.string(),
          sessionName: z.string(),
          startDate: z.string().describe("ISO date derived from first iteration start"),
          endDate: z.string().describe("ISO date derived from last iteration end"),
        })
        .describe("Session metadata for predictability chart x-axis"),
    )
    .describe("Sessions ordered by start_date (x-axis labels)"),
  overall: z
    .array(
      z.union([
        z
          .object({
            totalAvRatio: z
              .union([
                z.number().describe("total_av / committed_bv, null if BV <= 0"),
                z.null().describe("total_av / committed_bv, null if BV <= 0"),
              ])
              .describe("total_av / committed_bv, null if BV <= 0"),
          })
          .describe("Predictability ratio for a team or overall in a single session"),
        z.null(),
      ]),
    )
    .describe("One data point per session, summed across requested teams"),
  overallMissingAv: z.array(z.boolean()).describe("One bool per session for overall"),
  teams: z
    .array(
      z
        .object({
          teamId: z.number().int(),
          values: z
            .array(
              z.union([
                z
                  .object({
                    totalAvRatio: z
                      .union([
                        z.number().describe("total_av / committed_bv, null if BV <= 0"),
                        z.null().describe("total_av / committed_bv, null if BV <= 0"),
                      ])
                      .describe("total_av / committed_bv, null if BV <= 0"),
                  })
                  .describe("Predictability ratio for a team or overall in a single session"),
                z.null(),
              ]),
            )
            .describe("One per session, ordered. Null if team not in that session."),
          missingAv: z
            .array(z.boolean())
            .describe("One bool per session. True if any objective has av=None."),
        })
        .describe("Predictability data for a single team across sessions"),
    )
    .describe("One entry per requested team"),
});
